import { render, staticRenderFns } from "./sitedigital.vue?vue&type=template&id=b0f0c112&scoped=true&"
import script from "./sitedigital.vue?vue&type=script&lang=js&"
export * from "./sitedigital.vue?vue&type=script&lang=js&"
import style0 from "./sitedigital.vue?vue&type=style&index=0&id=b0f0c112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f0c112",
  null
  
)

export default component.exports